import { render, staticRenderFns } from "./FormRadioButtonField.vue?vue&type=template&id=bece1b38&scoped=true&"
import script from "./FormRadioButtonField.vue?vue&type=script&lang=ts&"
export * from "./FormRadioButtonField.vue?vue&type=script&lang=ts&"
import style0 from "./FormRadioButtonField.vue?vue&type=style&index=0&id=bece1b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bece1b38",
  null
  
)

export default component.exports